import { co2 } from './common';

export default {
  'consumption.co2': `${co2} 배출량`,
  'consumption.energy': '전력소모량',
  'consumption.fuel': '연료소모량',
  'footnotes.local':
    '주행거리는 표준 모드에 의한 연비로써 도로 상태, 운전 방법, 차량 적재, 정비 상태 및 외기 온도에 따라 실주행거리와 차이가 있습니다. 사양 및 옵션은 세부 모델에 따라 다르게 적용됩니다. 본 웹사이트에 기재된 내용은 사전에 예고 없이 변경될 수 있습니다.',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    '차량의 공식 연료소묘량 및 CO2 배출량에 대한 자세한 내용은 공인 Mercedes-Benz 전시장에 문의하시기 바랍니다.',
  'search.input.label': '검색어 / 모델 코드',
  'search.result.buy-online': '지금 주문하기',
  'search.results': `검색 결과가 없습니다. | {count} 개의 검색 결과`,
  'search.results.count': '{count} 개의 검색 결과',
  'search.results.backup': '검색과 일치하는 항목이 없습니다. 관련된 내용:',
  'search.results.none.summary': '검색 결과가 없습니다. 검색 옵션을 변경해서 다시 검색해 보세요.',
  'search.show-more': '검색 결과 더보기',
  'search.unavailable': '검색 기능을 현재 사용할 수 없습니다',
  'search.result.new': '',

  didyoumean: '이것을 찾으시나요',
  all: '모두',
  configurator: 'Configurator',
  collect: 'Collection & ACCESSORIES',
  connect: 'Mercedes me store',
  ncos: 'New Cars Online Store',
  ucos: 'Used Cars Online Store',
  dealer_locator: 'Dealer Locator',
  passenger_cars: 'Passenger Cars',
  test_drive: 'Test Drive',
  vans: 'Vans',
  vehicles_search: 'Vehicle Search',
  video: 'Video',
  related_search: '관련 검색',
  'input.placeholder': '검색어 / 모델 코드',

  'search.result.consumption': '	최근 검색함',
  'watch.video': '	동영상 보기',
  'input.recently': '	최근 검색함',
  'input.help.title': '무엇을 찾으십니까?',
  'input.help.text': '차량 유형, 모델, 구성 코드를 사용한 검색 또는 액세서리, 다른 제품 및 정보 검색',

  'search.result.grid': '網格',
  'search.result.list': '列表',

  //No results page
  'support.check': '오탈자는 없는지 확인하시고 다른 용어로 다시 시도해보십시오.',
  'support.no.results': '이 검색어에 해당하는 검색 결과가 없습니다.',
  'support.no.results.term': '검색 결과가 없습니다.',
  'support.chat': '검색하는 내용이 없습니까? 온라인 채팅 지원 기능을 이용해보십시오.',
};
